"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-sixteen/section/videoSection.tsx */

import { SmartImage } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeSixteenVideoSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    /** Default: "1s" */
    divDiv0DivDataWowDuration?: string;
    /** Default: "Play video" */
    divDiv0Div0Button0ButtonAriaLabel?: string;
    divDiv0Div0Button0ButtonVisible?: boolean;
    divDiv0Div0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: " Play Video  · Play Video · " */
    divDiv0Div0Button0Div0DivDataText?: string;
    /** Default: "video" */
    divDiv0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/video-bg.jpg" */
    divDiv0ImageWithBasePath0ImageSrc?: string;
    divDiv0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const HomeSixteenVideoSectionGenerated: FC<HomeSixteenVideoSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    divDiv0Div0Button0ButtonAriaLabel = "Play video",
    divDiv0Div0Button0ButtonVisible,
    divDiv0Div0Button0ButtonRenderer,
    divDiv0Div0Button0ButtonProps,
    divDiv0Div0Button0Div0DivDataText = " Play Video  · Play Video · ",
    divDiv0DivDataWowDuration = "1s",
    divDiv0ImageWithBasePath0ImageAlt = "video",
    divDiv0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/video-bg.jpg",
    divDiv0ImageWithBasePath0ImageVisible,
    divDiv0ImageWithBasePath0ImageRenderer,
    divDiv0ImageWithBasePath0ImageProps,
}) => {
    return (
        <>
            <div className="video-section-sixteen">
                <div className="video-block-sixteen wow zoomIn" data-wow-duration={divDiv0DivDataWowDuration}>
                    {renderNode(divDiv0ImageWithBasePath0ImageVisible, divDiv0ImageWithBasePath0ImageRenderer, (
                        <SmartImage src={divDiv0ImageWithBasePath0ImageSrc} alt={divDiv0ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(divDiv0ImageWithBasePath0ImageProps ?? {})} />
                    ))}
                    <div className="video-btn">
                        {renderNode(divDiv0Div0Button0ButtonVisible, divDiv0Div0Button0ButtonRenderer, (
                            <button type="button" aria-label={divDiv0Div0Button0ButtonAriaLabel} onClick={() => onOpenLightbox?.(0)} style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }} {...(divDiv0Div0Button0ButtonProps ?? {})}>
                                <div className="animate-button2" data-text={divDiv0Div0Button0Div0DivDataText}>
                                    <span className="button-text2" />
                                    <span className="button-circle">
                                        <i className="isax isax-play" />
                                    </span>
                                </div>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeSixteenVideoSectionGenerated;
